<template>
  <div class="step6Container">
    <div class="Container">
      <div class="Preview">
        <TabletPreview
          :order="order"
          :backColor="backColor"
          :frontColor="frontColor"
          :is-show-description="true"
        />
      </div>

      <div class="Forms" v-if="form.columns">
        <div class="Forms-Inner">
          <div class="child-inner">
            <!-- 配置ルール -->
            <OrderFormStep6PlacementRuleTab />
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="戒名・没年月日" name="first">
                <!-- 戒名 Tab -->
                <OrderFormStep6BuddhistNameTab />
                <!-- 年月日 Tab -->
                <OrderFormStep6DateOfDeathTab />
              </el-tab-pane>
              <el-tab-pane label="俗名・没年齢" name="second">
                <!-- 俗名 Tab -->
                <OrderFormStep6SecularNameTab />
                <!-- 年齢 Tab -->
                <OrderFormStep6AgeTab />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>

    <OrderFormFooter
      message="詳細情報を入力してください"
      :canClickGoBack="true"
      @onClickGoBack="onClickGoBack"
      :canClickGoForward="true"
      @onClickGoForward="onClickGoForward"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import UsecaseFactory from "@/usecases/usecase.factory.js";
import ProductUsecase from "@/usecases/product.usecase";
import { apiErrorHandler } from "@/services/apiErrorHandler";

// components
import OrderFormFooter from "@/components/OrderFormFooter";
import TabletPreview from "@/components/Common/TabletPreview.vue";
import OrderFormStep6PlacementRuleTab from "@/components/OrderFormStep6PlacementRuleTab.module";
import OrderFormStep6BuddhistNameTab from "@/components/OrderFormStep6BuddhistNameTab.module";
import OrderFormStep6SecularNameTab from "@/components/OrderFormStep6SecularNameTab.module";
import OrderFormStep6DateOfDeathTab from "@/components/OrderFormStep6DateOfDeathTab.module";
import OrderFormStep6AgeTab from "@/components/OrderFormStep6AgeTab.module";

export default {
  components: {
    OrderFormStep6PlacementRuleTab,
    OrderFormStep6BuddhistNameTab,
    OrderFormStep6SecularNameTab,
    OrderFormStep6DateOfDeathTab,
    OrderFormStep6AgeTab,
    OrderFormFooter,
    TabletPreview,
  },
  data () {
    return {
      productUsecase: new ProductUsecase(),
      activeName: "first",
    };
  },
  computed: {
    ...mapState({
      form: state => state.orderForm.detailInput,
      orderType: state => state.orderForm.orderTypeInput,
      typography: state => state.orderForm.typographyInput,
      printType: state => state.orderForm.typographyInput.printType,
      clientGroupInput: state => state.orderForm.clientGroupInput,
    }),
    ...mapGetters({
      previousStep: "orderForm/previousStep",
      nextStep: "orderForm/nextStep",
      order: "orderForm/order",
      frontColor: "orderForm/frontColor",
      backColor: "orderForm/backColor",
    }),
  },
  watch: {},
  async created () {
    try {
      const clientGroupId = this.clientGroupInput.id;
      const { font } = this.typography;

      // カテゴリ
      const categories = await this.productUsecase.getCategories(clientGroupId);

      this.categories = categories;

      // お気に入り異体字
      const favoriteVariantCharacters = await this.fetchFavoriteVariantCharacters(clientGroupId);
      const filteredFavoriteVariantCharacters = favoriteVariantCharacters.filter(character => character.font === font);

      this.$store.commit("orderForm/setFilteredFavoriteVariantCharacters", filteredFavoriteVariantCharacters);
    } catch (err) {
      apiErrorHandler(this, err);
    }
  },
  mounted () {
    this.$store.commit("orderForm/setCurrentStep", 4);
  },
  methods: {
    /**
     * [fetchFavoriteVariantCharacters description]
     * @param   {[type]}  clientGroupId  [clientGroupId description]
     * @return  {[type]}                 [return description]
     */
    async fetchFavoriteVariantCharacters (clientGroupId) {
      try {
        const options = { clientGroupId };
        const favoriteVariantCharacters = await favoriteVariantCharactersUsecase.getFavoriteVariantCharacters(options);

        this.$store.commit("orderForm/setFavoriteVariantCharacters", favoriteVariantCharacters);

        return favoriteVariantCharacters;
      } catch (err) {
        apiErrorHandler(this, err);
      }
    },

    onClickGoForward () {
      const { $router } = this;
      // const { form } = this;
      // const params = { ...form };
      // this.$store.commit("orderForm/setTypography", params);

      $router.push(this.nextStep);
    },
    onClickGoBack () {
      const { $router } = this;
      $router.push(this.previousStep);
    },
    _isSelected () {
      const { printType, font, frontColor, backColor } = this.form;
      return !!(printType && font && frontColor && backColor);
    },
    initFontOrLaterSelections () {
      this.font = null;
    },
    handleClick (tab, event) {
      console.log(tab, event);
    },
  },
};

const favoriteVariantCharactersUsecase = UsecaseFactory.create("favoriteVariantCharacters");
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.step6Container {
  height: 100%;
}
.Container {
  display: flex;
  grid-template-columns: repeat(2, 1fr);
  width: 1024px;
  margin: auto;
}
.Preview {
  flex: 1;
  height: 100%;
}
.Preview-ImageContainer {
  width: 400px;
  height: 100%;
  margin: auto;
}
.Preview-ImageContainer > img {
  width: 100%;
}

.Forms {
  flex: 1.2;
  height: calc(100vh - 100px - 88px);
}

.Forms-Inner {
  width: 94%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-right: 12px;
}
.Forms-Inner .child-inner {
  /* -webkit-transform: translate3d(0, 0, 0); */
  user-select: none;
}
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: $scrollbar-thumb;
}
.categories::after {
  content: "";
  /* flex: auto; */
}

.card {
  width: 200px;
  height: 250px;
  margin-bottom: 20px;
  cursor: pointer;
}

.card__image {
  width: 100%;
}

.title {
  font-weight: bold;
}

.description {
  color: gray;
}
.step6Container {
  touch-action: manipulation;
}
</style>
